import styled from 'styled-components';
import { Row, Col } from 'antd';

interface ProgressPartProps {
	percentage: number;
}

export const Content = styled(Row)`
	margin-left: 12px;
`;

export const InformationsContainer = styled.div`
	display: flex;
	justify-content: space-around;
	border: 1px solid #e8e8e8;
	width: 100%;
	border-radius: 10px;
`;

export const InformationInnerLeftContainer = styled.div`
	width: 30%;
	display: flex;
	text-align: left;
	align-items: center;
	justify-content: center;
	background-color: #f8f8f8;
`;

export const InformationInnerRightContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px 20px 20px 20px;
	width: 85%;

	p {
		margin: 0;
		font-size: 1rem;
	}
`;

export const StyledColForPercentage = styled(Col)`
	text-align: left;
`;

export const StyledColForCirlceIcon = styled(Col)`
	display: 'flex' !important;
	align-items: 'center' !important;
	justify-content: 'center' !important;
`;

export const StyledSpanForCirlceIcon = styled.span`
	display: 'flex' !important;
`;

export const StatusIncon = styled.span`
	display: 'inline-block';
	width: 7px;
	height: 7px;
	border-radius: 50%;
	margin-right: 8px;
`;

export const CustomParagraph = styled.p`
	font-size: 1.1rem;
	span {
		font-size: 1.2rem;
		font-weight: bold;
	}
`;

export const StyledPercentageDiv = styled.div`
	width: 100% !important;
	background-color: #e0e0e0 !important;
	height: 25px !important;
	border-radius: 30px !important;
	overflow: hidden !important;
	position: relative !important;
	display: flex !important;

	strong {
		font-weight: 600;
	}
`;

const ProgressPart = styled.div<ProgressPartProps>`
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	overflow: hidden;
	align-items: center;
	color: #fff;
	width: ${({ percentage }) => percentage}%;

	strong {
		font-size: 1rem;
	}
`;
export const MenExposed = styled(ProgressPart)`
	background-color: #2f54eb;
`;

export const WomenExposed = styled(ProgressPart)`
	background-color: #efac1e;
`;

export const OtherExposed = styled(ProgressPart)`
	background-color: #17a93b;
`;
